<template>
  <div class="my-layout-box">
    <!-- 基本信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>基本信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>公司全称：</span>
            <i class="c-three-color">{{ items.ClientName }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>业务联系人: </span>
            <i>{{ items.BusinessContact }}</i>
          </li>
          <li>
            <span>联系电话: </span>
            <i>{{ items.BusinessPhone }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>QQ: </span>
            <i>{{ items.QQ }}</i>
          </li>
          <li>
            <span>邮箱: </span>
            <i>{{ items.BusinessEmail }}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 公司信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>协议基本条款</span>
      </section>
      <section class="c-content-box" v-if="isCIF">
        <ul class="c-content-ul">
          <li>
            <span>报关方式: </span>
            <i class="c-one-color">单抬头 正能量开具增值税发票</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>货款汇率： </span>
            <i>{{ items.LoanRateTypeStr}}</i>
          </li>
          <li>
            <span>税款汇率：</span>
            <i>{{items.TaxRateTypeStr}}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>代理费汇率：</span>
            <i>{{ items.AgentFeeRateTypeStr}}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>服务期限：</span>
            <i>1年</i>
          </li>
          <li>
            <span>代理费率：</span>
            <i>{{items.AgentFeeRate}}%</i>
          </li>
          <li>
            <span>最低收费：</span>
            <i>{{items.MinCharge}}元</i>
          </li>
        </ul>
      </section>

      <section class="c-content-box" v-if="isFOB">
        <ul class="c-content-ul">
          <li>
            <span>报关方式: </span>
            <i class="c-four-color">双抬头 海关出具增值税发票</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>货款汇率： </span>
            <i>{{items.FOBLoanRateTypeStr }}</i>
          </li>
          <li>
            <span>税款汇率：</span>
            <i>{{items.FOBTaxRateTypeStr}}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>代理费汇率：</span>
            <i>{{ items.FOBAgentFeeRateTypeStr}}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>服务期限：</span>
            <i>1年</i>
          </li>
          <li>
            <span>代理费率：</span>
            <i>{{items.AgentFeeRate}}%</i>
          </li>
          <li>
            <span>最低收费：</span>
            <i>{{items.MinCharge}}元</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 开票信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>协议收件信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>收件人：</span>
            <i>{{items.ContractReceiver}}</i>
          </li>
          <li>
            <span>联系电话：</span>
            <i>{{items.ContractPhone}}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>协议寄送地址： </span>
            <i>{{items.ContractAddress}}</i>
          </li>
        </ul>
      </section>
    </section>
  </div>
</template>
<script>
import { getContract } from "~/api/userCenter";
export default {
  name: "contract",
  data() {
    return {
      items: {
        Id: 0,
        ClientName: "",
        BusinessContact: "",
        BusinessPhone: "",
        QQ: "",
        BusinessEmail: "",
        PackageTypeName: "",
        LoanRateTypeStr: "",
        TaxRateTypeStr: "",
        AgentFeeRateTypeStr: "",
        FOBLoanRateTypeStr: "",
        FOBTaxRateTypeStr: "",
        FOBAgentFeeRateTypeStr: "",
        AgentFeeRate: "",
        MinCharge: "",
        DealType: "",
        ContractReceiver: "",
        ContractPhone: "",
        ContractAddress: "",
        ContractStatus: 0,
        ContractId: 0,
        SignFlowEnabled: false,
        SignFlowId: null,
        SignFlowSigned: null
      },
      isCIF: false,
      isFOB: false
    };
  },
  methods: {
    async getData() {
      const data = await getContract();
      if (data) {
        Object.keys(this.items).forEach(key => {
          this.items[key] = data[key];
        });

        if (data.DealType == 1) {
          this.isFOB = true;
          this.isCIF = false;
        } else if (data.DealType == 2) {
          this.isFOB = false;
          this.isCIF = true;
        } else if (data.DealType == 3) {
          this.isFOB = true;
          this.isCIF = true;
        }
      }
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="less"></style>
